module.exports = __webpack_public_path__ + "img/third_red.a597b152.png";